import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class StocktakingApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.STOCKTAKING);
  }

  getList(params = {}) {
    const q = new URLSearchParams(params).toString();
    const url = q
      ? `${this.getResourceUrl()}list/?${q}`
      : `${this.getResourceUrl()}list/`;
    return this.httpClient.get(url);
  }

  download(id) {
    return this.httpClient.get(`${this.getResourceUrl()}${id}/download/`, {
      responseType: 'blob',
    });
  }

  upload(id, file) {
    const formData = new FormData();
    formData.append('file', file);
    return this.httpClient.post(
      `${this.getResourceUrl()}${id}/upload/`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
  }

  initialize(id) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${id}/initialize/`,
      {},
    );
  }

  apply(id) {
    return this.httpClient.patch(`${this.getResourceUrl()}${id}/apply/`, {});
  }

  reject(id) {
    return this.httpClient.patch(`${this.getResourceUrl()}${id}/reject/`, {});
  }

  complete(id) {
    return this.httpClient.patch(`${this.getResourceUrl()}${id}/complete/`, {});
  }

  abort(id) {
    return this.httpClient.patch(`${this.getResourceUrl()}${id}/abort/`, {});
  }

  excessDownload(id) {
    return this.httpClient.get(`${this.getResourceUrl()}${id}/excess/`, {
      responseType: 'blob',
    });
  }

  getOosDaily(params = {}) {
    const q = new URLSearchParams(params).toString();
    const url = q
      ? `${this.getResourceUrl()}oos-daily/?${q}`
      : `${this.getResourceUrl()}oos-daily/`;
    return this.httpClient.get(url);
  }
}

export default new StocktakingApi();
